/**
 * Chuỗi hiển thị của nhóm màn hình Thiết bị & Tổng quan (MH-01, MH-02, danh sách
 * MH-24, Quản trị thiết bị) dựng theo bản mẫu CMS "Thông tin nguồn".
 *
 * Chuỗi dùng chung đã có trong `vi.ts` thì đọc từ đó, tệp này chỉ chứa chuỗi MỚI.
 */
export const viThietBi = {
  chung: {
    tatCa: 'Tất cả',
    toanPhamVi: 'Toàn bộ phạm vi được phân công',
    chuaCo: '—',
    dangTai: 'Đang tải…',
    khongTaiDuoc: 'Không tải được số liệu',
  },

  /* ------------------------ Ô tóm tắt thiết bị (DeviceSummary) ---------------- */
  tomTat: {
    nhan: 'Tóm tắt trạng thái thiết bị',
    thietBi: 'Thiết bị',
    dangKetNoi: 'Đang kết nối',
    matKetNoi: 'Mất kết nối',
    dangPhat: 'Đang phát',
    khongPhat: 'Không phát',
    ghiChuDangKetNoi:
      'Đang kết nối = tổng trừ mất kết nối và chưa kích hoạt; không phát gồm chờ phát và tạm dừng.',
  },

  /* --------------------------- Đếm ngược làm mới ------------------------------ */
  demNguoc: {
    sau: 'Dữ liệu được cập nhật sau : {so} s',
    tamDung: 'Tạm dừng tự làm mới',
  },

  /* Cột "Kết nối" của danh sách thiết bị: bốn chỉ báo. */
  ketNoi: {
    dangKetNoi: 'Đang kết nối',
    matKetNoi: 'Mất kết nối',
    daDongBo: 'Đã đồng bộ lên hệ thống nguồn trung ương',
    chuaDongBo: 'Chưa đồng bộ lên hệ thống nguồn trung ương',
    dangPhat: 'Đang phát',
    khongPhat: 'Không phát',
    kenh: {
      api: 'Kết nối gián tiếp qua API bộ tương thích của nhà cung cấp',
      mqtt: 'Kết nối trực tiếp qua MQTT',
      ws: 'Kết nối trực tiếp qua Websocket',
    } as Record<string, string>,
  },

  /* --------------------------- Khối danh sách thiết bị ------------------------ */
  /* Hộp Phát khẩn cấp (DV003) mở từ nút Phát ngay của trang Cụm loa. */
  phatKhanCap: {
    tieuDe: 'Phát khẩn cấp',
    dong: 'Đóng',
    dichDiaBan: 'Địa bàn : {ten}',
    dichThietBi: '{so} thiết bị đã chọn: {ds}{them}',
    chuaCoDiaBan: 'Chưa xác định được địa bàn phát — chọn địa bàn ở menu người dùng hoặc tích chọn thiết bị.',
    cot: {
      stt: 'STT',
      tieuDe: 'Tiêu đề',
      thoiLuong: 'Thời lượng',
      loaiBanTin: 'Loại bản tin',
      mucDoUuTien: 'Mức độ ưu tiên',
      loaiLinhVuc: 'Loại lĩnh vực',
      xemLai: 'Xem lại',
      nguoiTao: 'Người tạo',
      thaoTac: 'Thao tác',
    },
    xemLaiNhan: 'Xem lại bản tin {tieuDe}',
    chuaCoAmThanh: 'Bản tin "{tieuDe}" chưa có âm thanh nghe thử.',
    phatKhanCap: 'Phát khẩn cấp',
    xacNhanTieuDe: 'Phát thiết bị',
    huy: 'Hủy',
    dongY: 'Đồng ý',
    dangGui: 'Đang gửi…',
    dangTai: 'Đang tải danh sách bản tin…',
    loiTai: 'Không tải được danh sách bản tin.',
    rong: 'Chưa có bản tin đã duyệt.',
    tong: 'Tổng {so} bản ghi',
    lyDo: 'Phát khẩn cấp từ trang Cụm loa — {dich}',
    daGui: 'Đã gửi lệnh phát khẩn cấp "{tieuDe}" — {dich}.',
    loi: 'Không gửi được lệnh phát: {loi}',
  },

  danhSach: {
    tieuDeCumLoa: 'Cụm loa',
    tieuDeBangDienTu: 'Bảng điện tử',
    donViHanhChinh: 'Đơn vị hành chính',
    trangThai: 'Trạng thái',
    chonTrangThai: 'Chọn trạng thái',
    maThietBi: 'Mã hoặc tên thiết bị',
    maThietBiGoiY: 'Nhập mã thiết bị',
    nhaCungCap: 'Nhà cung cấp',
    chonNhaCungCap: 'Nhà cung cấp',
    phienBanGoiY: 'Phiên bản phần mềm',
    timKiem: 'Tìm kiếm',
    xuatExcel: 'Xuất Excel',
    dangXuatExcel: 'Đang xuất…',
    daXuatExcel: 'Đã xuất {so} thiết bị ra tệp Excel',
    loiXuatExcel: 'Không xuất được Excel: {loi}',
    phatTheoLich: 'Phát theo lịch',
    dieuKhien: 'Điều khiển',
    phatNgay: 'Phát ngay',
    maLich: 'Mã lịch',
    phatNgayGoiY: 'Chọn ít nhất một thiết bị trong bảng để phát ngay',
    dieuKhienGoiY: 'Chọn ít nhất một thiết bị trong bảng để điều khiển',
    amLuong: 'Âm lượng',
    giaTriAmLuong: 'Giá trị âm lượng',
    capNhat: 'Cập nhật',
    amLuongGoiY: 'Chọn thiết bị trong bảng rồi bấm Cập nhật để gửi lệnh đặt âm lượng',
    xacNhanAmLuongTieuDe: 'Đặt âm lượng cho thiết bị đã chọn',
    daCapNhatAmLuong: 'Đã cập nhật âm lượng cho thiết bị',
    hoiAmLuongTieuDe: 'Cập nhật âm lượng',
    hoiAmLuong: 'Bạn chắc chắn cập nhật lệnh?',
    khongDongY: 'Không đồng ý',
    dongY: 'Đồng ý',
    dangGui: 'Đang gửi lệnh…',
    cot: {
      stt: 'STT',
      ketNoi: 'Kết nối',
      diaBan: 'Địa bàn',
      tenThietBi: 'Tên thiết bị',
      amLuong: 'Âm lượng',
      noiDungPhat: 'Nội dung đang phát',
      lichPhatMoiNhat: 'Lịch phát mới nhất',
      capNhatLuc: 'T/G cập nhật',
      maNhaCungCap: 'Mã nhà cung cấp',
      nhietDo: 'Nhiệt độ',
      dongDien: 'Dòng điện',
      mangDungLuong: 'Mạng, Dung lượng dùng',
      phienBan: 'Phiên bản',
      maThietBi: 'Mã thiết bị',
      thaoTac: 'Thao tác',
    },
    doC: '°C',
  },

  /* ------------------------------ MH-01 Tổng quan ----------------------------- */
  tongQuan: {
    banTinDaXuatBan: 'Số bản tin đã xuất bản',
    // Khoá là mã loại bản tin của `GET /bulletins/statistics` (Công văn 276 —
    // đúng năm loại, không có bản tin FM).
    loaiBanTin: [
      ['1', 'Bản tin văn bản'],
      ['2', 'Bản tin hình ảnh'],
      ['3', 'Bản tin âm thanh'],
      ['4', 'Bản tin video'],
      ['5', 'Bản tin trực tiếp'],
    ],
    banTinDaPhatTrongNgay: 'Số bản tin đã phát trong ngày',
    banTinDaPhatGhiChu: 'Đếm theo lượt phát ghi trong nhật ký phát từ 0 giờ hôm nay',
    cumLoaTruyenThanh: 'Cụm loa truyền thanh',
    bangDienTu: 'Bảng điện tử',
    bangTinDienTuCongCong: 'Bảng tin điện tử công cộng',
    banDoSo: 'Bản đồ số',
    loaiThietBi: 'Loại thiết bị',
    cumLoa: 'Cụm loa',
    trangThaiKetNoi: 'Trạng thái kết nối',
    danhSachThietBi: 'Danh sách thiết bị',
    khongCoThietBi: 'Chưa có thiết bị trong phạm vi',
    soLoaGoiY: 'Cụm loa: {ket} đang kết nối / {tong} thiết bị',
    soBangGoiY: 'Bảng điện tử: {ket} đang kết nối / {tong} thiết bị',
    xemTatCa: 'Xem tất cả',
    banDoGhiChu:
      'Bản đồ gom nhóm thiết bị theo toạ độ và chỉ lọc theo đơn vị hành chính; trạng thái kết nối và loại thiết bị lọc danh sách bên phải.',
    banDoRong: 'Chưa có thiết bị nào có toạ độ trong phạm vi này.',
    khongCoToaDo: 'Thiết bị chưa có toạ độ',
    chuGiaiDangKetNoi: 'Toàn bộ đang kết nối',
    chuGiaiCoMatKetNoi: 'Có thiết bị mất kết nối',
    nhomThietBi: '{so} thiết bị, {mat} mất kết nối',
    theXaMa: 'Mã định danh',
    theXaLoa: 'Cụm thu phát thanh',
    theXaBang: 'Bảng tin điện tử công cộng',
    theXaKetNoi: 'Trạng thái kết nối',
    theXaHoatDong: 'Trạng thái hoạt động',
    theXaCapNhat: 'Cập nhật',
    loa: 'Loa',
    bang: 'Bảng',
    moDanhSach: 'Mở danh sách đã lọc',
  },

  /* ------------------------------- Quản trị kho -------------------------------- */
  quanTri: {
    tieuDe: 'Quản lý kho thiết bị kết nối',
    themMoi: 'Thêm mới',
    timTheoTen: 'Tìm theo tên thiết bị...',
    nhanTimTheoTen: 'Tên thiết bị',
    kichHoatThayThe: 'Kích hoạt thay thế',
    dangKyDaChon: 'Đăng ký thiết bị (đã chọn)',
    dangKyTatCa: 'Đăng ký tất cả thiết bị',
    xoaDaChon: 'Xoá thiết bị đã chọn',
    cot: {
      stt: 'STT',
      diaDiem: 'Địa điểm lắp đặt',
      tenThietBi: 'Tên thiết bị',
      maThietBi: 'Mã thiết bị',
      ngayCapNhat: 'Ngày cập nhật',
      thaoTac: 'Thao tác',
    },
    xoa: 'Xóa',
    chinhSua: 'Chỉnh sửa',
    xoaTieuDe: 'Xoá thiết bị khỏi kho',
    xoaHeQua: 'Xoá {so} thiết bị: {ten}. Thiết bị sẽ không còn nhận lịch phát và lệnh điều khiển.',
    xoaNhieuHeQua:
      'Xoá {so} thiết bị đã chọn. Các thiết bị này sẽ không còn nhận lịch phát và lệnh điều khiển.',
    daXoa: 'Đã xoá {so} thiết bị.',
    xoaLoi: 'Không xoá được {so} thiết bị: {loi}',

    /* Tab của trang: kho chờ đăng ký / đã đăng ký. */
    tabKho: 'Kho chờ đăng ký',
    tabDaDangKy: 'Đã đăng ký vào hệ thống',
    tieuDeDaDangKy: 'Thiết bị đã đăng ký',
  },

  /* Kho thiết bị kết nối: thiết bị phát hiện qua DV008 chờ duyệt đăng ký. */
  kho: {
    hopTieuDe: 'Danh sách thiết bị kết nối',
    hopMoTa:
      'Thiết bị chưa đăng ký đã gửi trạng thái (DV008) lên — qua hệ thống của nhà cung cấp hoặc tự kết nối trực tiếp. Chọn thiết bị rồi bấm "Đăng ký" để đưa vào kho chờ đăng ký.',
    nhapExcel: 'Nhập Excel',
    khaiBaoThuCong: 'Khai báo thủ công',
    huy: 'Hủy',
    dangKy: 'Đăng ký',
    daDuaVaoKho: 'Đã đưa {so} thiết bị vào kho chờ đăng ký.',
    rongPhatHien:
      'Chưa có thiết bị mới nào gửi dữ liệu lên. Thiết bị xuất hiện ở đây khi hệ thống của nhà cung cấp gửi DV008 cho mã thiết bị chưa đăng ký, hoặc khi thiết bị kết nối trực tiếp tự kích hoạt và gửi DV008 đầu tiên.',
    rongKho: 'Kho đang trống. Bấm "Thêm mới" để chọn thiết bị từ danh sách thiết bị kết nối.',
    cot: {
      stt: 'STT',
      ketNoi: 'Kết nối',
      diaBan: 'Địa bàn',
      diaDiem: 'Địa điểm lắp đặt',
      tenThietBi: 'Tên thiết bị',
      maThietBi: 'Mã thiết bị',
      amLuong: 'Âm lượng',
      capNhat: 'T/G cập nhật',
      maNhaCungCap: 'Mã nhà cung cấp',
      nhietDo: 'Nhiệt độ',
      phienBan: 'Phiên bản',
      thaoTac: 'Thao tác',
      phuongThuc: 'Phương thức kết nối',
    },
    /** Cột "Phương thức kết nối": thiết bị MQTT tự kích hoạt hay qua bộ tương thích. */
    phuongThuc: { truc_tiep: 'Trực tiếp', gian_tiep: 'Qua bộ tương thích' },
    ngoaiDanhMuc: 'Ngoài danh mục — chọn địa bàn',
    chuaXacDinhXa: 'Chưa xác định xã',
    chonXaKhiDangKy: 'Chọn xã/phường khi đăng ký',
    nhanNccTrucTiep: 'Nhà cung cấp (thiết bị trực tiếp)',
    nccTheoThietBi: 'Theo thiết bị tự báo',
    canChonNcc: 'Chọn nhà cung cấp cho thiết bị kết nối trực tiếp chưa có nhà cung cấp',
    /** TrangThaiHoatDong của DV008: 0 đang phát, 1 tạm dừng, 2 không phát. */
    hoatDong: { '0': 'Đang phát', '1': 'Tạm dừng', '2': 'Không phát' } as Record<string, string>,
    dangKetNoi: 'Đang kết nối',
    matKetNoi: 'Mất kết nối',
    dangKyDaChonTieuDe: 'Đăng ký thiết bị vào hệ thống',
    dangKyHeQua:
      'Đăng ký {so} thiết bị vào hệ thống{diaBan}. Thiết bị giữ phương thức kết nối đang có (trực tiếp qua MQTT hoặc qua bộ tương thích của nhà cung cấp) và bắt đầu nhận lịch phát, lệnh điều khiển.',
    dangKyTaiDiaBan: ' tại {ten}',
    canChonXa:
      'Chọn đúng xã/phường mà thiết bị báo về ở ô "Đơn vị hành chính" để đăng ký. Thiết bị báo sai xã: dùng "Chỉnh sửa" để sửa địa bàn trước.',
    dangKyTatCaHeQua:
      'Đăng ký TẤT CẢ {so} thiết bị trong kho báo về{diaBan}. Thiết bị giữ phương thức kết nối đang có (trực tiếp hoặc qua bộ tương thích).',
    daDangKy: 'Đã đăng ký {ok}/{tong} thiết bị vào hệ thống.',
    /** Thiết bị trực tiếp đăng ký khi chưa hoàn tất DV018 (chưa có mật khẩu chờ chuyển). */
    canKichHoat:
      '{ma}: đã đăng ký nhưng thiết bị chưa hoàn tất kích hoạt — thiết bị cần gọi DV001 (Username = Password = mã thiết bị) rồi DV018 để nhận mật khẩu.',
    dangKyLoi: '{so} thiết bị chưa đăng ký được:',
    xoaKhoTieuDe: 'Xoá thiết bị khỏi kho',
    xoaKhoHeQua:
      'Đưa {so} thiết bị ra khỏi kho chờ đăng ký. Thiết bị quay lại "Danh sách thiết bị kết nối", không bị xoá khỏi dữ liệu.',
    daXoaKho: 'Đã xoá {so} thiết bị khỏi kho.',
    suaTieuDe: 'Chỉnh sửa thiết bị trong kho',
    suaTen: 'Tên thiết bị',
    suaDiaBan: 'Địa bàn (xã)',
    luu: 'Lưu',
    daSua: 'Đã cập nhật thiết bị {ma}.',
  },
} as const;
